var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',{attrs:{"id":"play-to-earn"}},[_c('div',{staticClass:"container"},[_c('h2',{staticClass:"section-title"},[_vm._v("PLAY   TO   EARN   FEATURES")]),_c('div',{staticClass:"playtoearn text-center"},[_c('img',{staticClass:"img-fluid",attrs:{"src":require("@/assets/images/play-to-earn/full.png"),"alt":""}})])])])
}]

export { render, staticRenderFns }